// /frontend/src/services/api/student.js
import api from '@/services/api';

export const studentApi = {
  // Autovervollständigung für Schülernamen (auch für Lehrkräfte nutzbar)
  searchStudents(params = { q: '' }) {
    const qs = new URLSearchParams();
    if (params.q) qs.set('q', params.q);
    return api.get(`/students/search?${qs.toString()}`);
  },

  // Status eines Schülers anhand des Namens abrufen
  getStudentStatus(params = { name: '' }) {
    const qs = new URLSearchParams();
    if (params.name) qs.set('name', params.name);
    return api.get(`/students/status?${qs.toString()}`);
  }
};
